import Vue, { computed, getCurrentInstance } from 'vue'
import type { WritableComputedRef } from 'vue'
import { VueConstructor } from 'vue/types/umd'
import VueI18n, { LocaleMessages } from "vue-i18n"
import { loadLocaleMessages as loadComponentsLocaleMessages } from "@coredination/components"

Vue.use(VueI18n)

function loadLocaleMessages(): LocaleMessages {
    const messages: LocaleMessages = {}
    Object.assign(messages, loadComponentsLocaleMessages())
    const locales = require.context("./locales", true, /[A-Za-z0-9-_,\s]+\.json$/i)
    locales.keys().forEach((key) => {
        const matched = key.match(/([A-Za-z0-9-_]+)\./i)
        if (matched && matched.length > 1) {
            const locale = matched[1]
            Object.assign(messages[locale], locales(key))
        }
    })
    return messages
}

let language =
    (navigator.languages && navigator.languages[0]) || // Chrome / Firefox
    navigator.language ||
    "en"

let uri = window.location.search.substring(1)
let params = new URLSearchParams(uri)
if (params.has("language")) language = params.get("language")!
if (language.length > 2) language = language.substring(0, 2)
if (language == "nn") language = "nb"

let i18nInstance = new VueI18n({
    locale: language || process.env.VUE_APP_I18N_LOCALE || "en",
    fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || "en",
    messages: loadLocaleMessages(),
})

// hacked in the useI18n below. It's part of vue-i18n 9.x, but needs to be manually added in 8.x
export default i18nInstance

export interface Composer {
    locale: WritableComputedRef<string>
    t: typeof VueI18n.prototype.t
    tc: typeof VueI18n.prototype.tc
    te: typeof VueI18n.prototype.te
    d: typeof VueI18n.prototype.d
    n: typeof VueI18n.prototype.n
  }
  
  export function useI18n(): Composer {
    if (!i18nInstance) throw new Error('vue-i18n not initialized')
  
    const i18n = i18nInstance
  
    const instance = getCurrentInstance()
    const vm =
      instance?.proxy ||
      (instance as unknown as InstanceType<VueConstructor>) ||
      new Vue({})
  
    const locale = computed({
      get() {
        return i18n.locale
      },
      set(v: string) {
        i18n.locale = v
      }
    })
  
    return {
      locale,
      t: vm.$t.bind(vm),
      tc: vm.$tc.bind(vm),
      d: vm.$d.bind(vm),
      te: vm.$te.bind(vm),
      n: vm.$n.bind(vm)
    }
  }